import { render, staticRenderFns } from "./Teste.vue?vue&type=template&id=38fef223"
import script from "./Teste.vue?vue&type=script&lang=js"
export * from "./Teste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports